import { find, isEmpty } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from '../Deliveries.module.css';
import VendorSelector from '../../ReusableComponents/VendorSelector/VendorSelector';
import Button from '../../ReusableComponents/Button/Button';

const validate = (vendor) => !isEmpty(vendor) && !isEmpty(vendor.value);

class SelectVendor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendor: props.vendor,
      error: null,
    };

    this.onChange = this.onChange.bind(this);
    this.next = this.next.bind(this);
  }

  onChange(vendor) {
    const { onChange, vendors } = this.props;
    this.setState({ vendor }, () => {
      onChange(find(vendors, (v) => v.id === vendor.value));
    });
  }

  next() {
    const { next } = this.props;
    const { vendor } = this.state;
    const isValid = validate(vendor);

    if (!isValid) {
      const error = `Please select an active vendor`;

      this.setState({ error });
    } else {
      next();
    }
  }

  render() {
    const { fetchVendors, onClose, vendors } = this.props;
    const { error, vendor } = this.state;

    return (
      <div className={styles.step}>
        <div className={styles.stepContainer}>
          <div className={styles.stepHeader}>
            <h3>Select A Vendor:</h3>
          </div>

          <div className={styles.stepBody}>
            <div className={styles.vendorSelector}>
              <VendorSelector
                approvedOnly
                vendors={vendors}
                value={vendor}
                searchVendors={(search) => {
                  fetchVendors(`search=${search}`);
                }}
                onChange={this.onChange}
              />
            </div>
          </div>

          <div className={styles.stepActions}>
            <Button
              onClick={onClose}
              color="primary"
              className={styles.cancelButton}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={this.next}
              color="white"
              className={styles.nextButton}
              variant="outlined"
            >
              Next
            </Button>
          </div>

          <div className={styles.error}>{error}</div>
        </div>
      </div>
    );
  }
}

SelectVendor.propTypes = {
  next: PropTypes.func.isRequired,
  fetchVendors: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  vendor: PropTypes.shape({}),
  vendors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

SelectVendor.defaultProps = {
  vendor: null,
};

export default SelectVendor;
